import {LocalParams} from "../../components/LocalParams";
import {AssociatedProduct, FavouriteProducts} from "./Product";

export interface LoginData {
  token:      string;
  customer:   UserData | null;
  email:      string;
  password:   string;
  firstName:  string;
  lastName:   string;
}

export interface UserDto {
  userName: string | null;
  customer: UserData | null;
  firstName: string | null;
  lastName: string | null;
  token: string | null;
  tokenCart: string | null;
}

export interface UserData {
  id:                           number;
  firstName:                    string|null;
  lastName:                     string|null;
  email:                        string|null;
  password:                     string|null;
  subscribedToNewsletter:       boolean;
  birthplace:                   string|null;
  nationalRegistrationNumber:   string|null;
  street:                       string|null;
  zip:                          string|null;
  city:                         string|null;
  countryCode:                  string|null;
  companyStreet:                string|null;
  companyZip:                   string|null;
  companyCity:                  string|null;
  companyCountryCode:           string|null;
  companyName:                  string|null;
  taxNumber:                    string|null;
  jointCommittee:               string|null;
  sectoralFund:                 string|null;
  fax:                          string|null;
  jobFunction:                  string|null;
  jobDepartment:                string|null;
  phoneNumber:                  string|null;
  customerType:                 string|null;
  hasAcceptedConditions:        boolean;
  birthday:                     string|null;
  tokenCart:                    string|null;
  addresses:               UserAddresses[];
  favouriteProducts :      FavouriteProducts[],
  suggestedProducts:        AssociatedProduct[];
  defaultAddress: string,
}

export interface UserAddresses{
  id:                      number|null;
  street:                  string|null;
  postcode:                string|null;
  city:                    string|null;
  countryCode:             string|null;
}

export class User {
  userDto: UserDto|null;

  constructor(userDto: UserDto|null) {
    this.userDto = userDto;
  }

  public getToken(): string|null {
    return(LocalParams.getItem('token'));
  }

  public storeParams(): void {
    if (this.userDto) {
      if (this.userDto.userName) {
        LocalParams.setItem('user', this.userDto.userName);
      }
      if (this.userDto.customer) {
        LocalParams.setItem('customer', JSON.stringify(this.userDto.customer));
        if (this.userDto.customer.tokenCart) {
          LocalParams.setItem('tokenCart', this.userDto.customer.tokenCart);
        }
      }
      if (this.userDto.token) {
        LocalParams.setItem('token', this.userDto.token);
      }
      if (this.userDto.firstName) {
        LocalParams.setItem('firstName', this.userDto.firstName);
      }
      if (this.userDto.lastName) {
        LocalParams.setItem('lastName', this.userDto.lastName);
      }
    }
  }

  public deleteParams() : null {
    LocalParams.removeItem('user');
    LocalParams.removeItem('customer');
    LocalParams.removeItem('token');
    LocalParams.removeItem('firstName');
    LocalParams.removeItem('lastName');
    LocalParams.removeItem('tokenCart');
    LocalParams.removeItem('tokenOfferCart');
    LocalParams.removeItem('productsSelection')
    return null;
  }

  static create(): User | null {
    const userName = LocalParams.getItem('user');
    const token = LocalParams.getItem('token');
    const firstName = LocalParams.getItem('firstName');
    const lastName = LocalParams.getItem('lastName');
    const tokenCart = LocalParams.getItem('tokenCart');

    let customer: UserData | null = null;
    const customerStr = LocalParams.getItem('customer');
    try {
      if (customerStr) {
        customer = JSON.parse(customerStr);
      }
    } catch (e) {
      console.warn("Parsing failed for customer", customerStr);
    }

    const newUser = new User({ userName, customer, token, firstName, lastName, tokenCart });
    return newUser;
  }


  public isAuthenticated(): boolean {
    return((this.userDto !== null) && (this.userDto.token!== null));
  }
}

export enum customerType {
  COMPANY = "COMPANY"
}
